import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackEvent } from '../lib/metaPixel';
const handleCheckoutClick = () => trackEvent('InitiateCheckout', {
  value: 19990,
  currency: 'ARS',
  content_name: 'MegaPack Pastelería Premium'
});
const INCLUDES = ['6 Tomos Premium', '6 Bonos Exclusivos', 'Acceso Inmediato', 'Acceso Permanente', 'Garantía de 7 días'];
export function FinalCTASection() {
  const [refPricing, visPricing] = useReveal();
  const [refClose, visClose] = useReveal();
  return <section id="cta" className="relative py-14 md:py-20 px-6 overflow-hidden bg-gradient-to-b from-[#fff8f9] via-[#fdf2f4] to-[#fce7e9]/60" data-id="element-78">
      <div className="absolute inset-0 -z-10 pointer-events-none" data-id="element-79">
        <div className="absolute top-[10%] left-[10%] w-[40%] h-[40%] rounded-full bg-[#f8d7da] blur-[120px] opacity-50" data-id="element-80"></div>
        <div className="absolute bottom-[10%] right-[10%] w-[40%] h-[40%] rounded-full bg-[#fce7e9] blur-[120px] opacity-60" data-id="element-81"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto" data-id="element-82">
        {/* Pricing block */}
        <div ref={refPricing} className={`reveal text-center mb-8 ${visPricing ? 'is-visible' : ''}`} data-id="element-83">
          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-84">
            ♡ Hoy podés acceder ♡
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a] mb-3 leading-tight" data-id="element-85">
            Hoy podés acceder al <br data-id="element-86" />
            <span className="italic text-[#e89aaa]" data-id="element-87">MegaPack completo.</span>
          </h2>
        </div>

        <div className="mb-10" data-id="element-88">
          <div className="relative bg-gradient-to-br from-white to-[#fdf2f4] rounded-[2rem] p-8 md:p-12 border-2 border-[#e89aaa]/60 shadow-[0_15px_50px_rgba(232,154,170,0.18)] flex flex-col max-w-md mx-auto" data-id="element-89">
            <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#e89aaa] text-white text-[10px] font-bold tracking-[0.25em] uppercase px-4 py-1.5 rounded-full shadow-md whitespace-nowrap" data-id="element-90">
              ♡ Oferta de Lanzamiento ♡
            </span>

            <div className="text-center mb-6 mt-2" data-id="element-91">
              <h3 className="text-2xl font-serif font-bold text-[#6b4f3a] mb-4" data-id="element-92">
                MegaPack Pastelería
              </h3>

              <div className="flex flex-col items-center gap-1" data-id="element-93">
                <span className="text-[#8b6f47]/60 line-through text-base font-medium" data-id="element-94">
                  $39.990 ARS
                </span>
                <div className="flex items-baseline justify-center gap-2" data-id="element-95">
                  <span className="font-serif font-bold text-5xl md:text-6xl text-[#e89aaa] leading-none" data-id="element-96">
                    $19.990
                  </span>
                  <span className="text-[#8b6f47] text-sm font-medium" data-id="element-97">
                    ARS
                  </span>
                </div>
                <span className="mt-2 inline-block bg-[#fdf2f4] text-[#e89aaa] text-[10px] font-bold tracking-[0.2em] uppercase px-3 py-1 rounded-full" data-id="element-98">
                  50% OFF por tiempo limitado
                </span>
              </div>
            </div>

            <ul className="space-y-2.5 mb-6" data-id="element-99">
              {INCLUDES.map((item, i) => <li key={i} className="flex items-center gap-3 text-[#6b4f3a]" data-id="element-100">
                  <span className="w-5 h-5 rounded-full bg-[#e89aaa] flex items-center justify-center text-white text-xs shrink-0" data-id="element-101">
                    ✓
                  </span>
                  <span className="text-sm font-medium" data-id="element-102">{item}</span>
                </li>)}
            </ul>

            <a href="https://ebooksolutions.online/cart/46407716077622:1" target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="cta-btn block w-full px-6 py-4 rounded-full bg-[#e89aaa] hover:bg-[#d98ba0] text-white font-medium text-sm md:text-base tracking-wider text-center shadow-[0_8px_20px_rgba(232,154,170,0.35)] hover:shadow-[0_12px_25px_rgba(232,154,170,0.45)]" data-id="element-103">
              QUIERO ACCEDER AHORA ♡
            </a>

            <p className="text-center text-[10px] text-[#8b6f47]/70 tracking-wider uppercase mt-3" data-id="element-104">
              🔒 Pago seguro · ⚡ Acceso inmediato
            </p>
          </div>
        </div>

        {/* Emotional close */}
        <div ref={refClose} className={`reveal bg-white/80 backdrop-blur-md rounded-[2rem] p-8 md:p-12 border border-[#f4b6c2]/40 shadow-[0_20px_50px_rgba(232,154,170,0.12)] text-center ${visClose ? 'is-visible' : ''}`} data-id="element-105">
          <p className="font-serif italic text-base text-[#e89aaa] mb-3" data-id="element-106">
            ♡ Tu momento es ahora ♡
          </p>

          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a] mb-4 leading-tight" data-id="element-107">
            Tal vez hoy solo sea <br data-id="element-108" />
            <span className="italic text-[#e89aaa]" data-id="element-109">una pasión…</span>
          </h2>

          <p className="text-sm md:text-base text-[#8b6f47] mb-6 max-w-xl mx-auto" data-id="element-110">
            Pero con práctica, creatividad y constancia… puede convertirse en
            algo mucho más grande.
          </p>

          <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-111">
            {['Tu marca', 'Tu emprendimiento', 'Tus primeros clientes', 'Tus propias creaciones premium'].map((item, i) => <span key={i} className="inline-flex items-center gap-1.5 text-sm text-[#8b6f47] bg-[#fdf2f4] border border-[#f4b6c2]/40 rounded-full px-4 py-2" data-id="element-112">
                ✨ {item}
              </span>)}
          </div>

          <a href="https://ebooksolutions.online/cart/46407716077622:1" target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="cta-btn inline-block w-full sm:w-auto px-10 py-5 rounded-full bg-[#e89aaa] hover:bg-[#d98ba0] text-white font-medium text-base md:text-lg tracking-wider text-center shadow-[0_8px_20px_rgba(232,154,170,0.35)] hover:shadow-[0_12px_25px_rgba(232,154,170,0.45)]" data-id="element-113">
            QUIERO ACCEDER AL MEGAPACK ♡
          </a>

          <p className="mt-6 text-xs text-[#8b6f47]/70 tracking-wider uppercase" data-id="element-114">
            🔒 Pago seguro · ⚡ Acceso inmediato · 🛡️ Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}